document.addEventListener('DOMContentLoaded', function () {
    const navigationSelector = '.infographic-circle__navigation-image';
    const tooltipSelector = '.infographic-circle__tooltip';
    const openIcon = '//fluffandboots.com/cdn/shop/files/fluff-cat.svg?crop=center&height=80&v=1727429067&width=80';

    document.querySelectorAll(navigationSelector).forEach(function (circle) {
        circle.addEventListener('click', function () {
            // Check if the clicked circle is already active
            const isActive = circle.classList.contains('is-active');
            const parent = circle.parentElement;
            const parentChildTooltip = parent.querySelector(tooltipSelector);

            // Hide all tooltip
            resetInfographNavigations();

            parent.style.zIndex = 2;
            circle.style.zIndex = 1;

            // If it was already active, just remove it and return
            if (isActive) {
                return;
            }

            // Add active state
            circle.classList.add('is-active');

            // Show the clicked circle's tooltip
            parentChildTooltip.style.display = 'block';
            
            // Adjust the z-index
            parent.style.zIndex = 2;
            circle.style.zIndex = 2;
            parentChildTooltip.style.zIndex = 1;

            // Set default cat icon
            circle.style.backgroundImage = `url('${openIcon}')`;
        });

        // Hide the tooltip when clicking anywhere else on the document
        document.addEventListener('click', function (event) {
            if (! circle.contains(event.target)) {
                circle.classList.remove('is-active');
                const circleParent = circle.parentElement;
                const circleTooltip = circleParent.querySelector(tooltipSelector);

                if (circleTooltip) {
                    circleTooltip.style.display = 'none';
                }
            }
        });
    });

    function resetInfographNavigations() {
        // Remove other active navigations
        document.querySelectorAll(navigationSelector).forEach(function (navigation) {
            navigation.classList.remove('is-active');
            navigation.style.zIndex = 2;
            navigation.style.backgroundImage = 'var(--navigation-image-src)';
        });

        // Hide all tooltips
        document.querySelectorAll(tooltipSelector).forEach(function (tooltip) {
            tooltip.style.display = 'none';
            tooltip.style.zIndex = 1;
        });
    }

    setTimeout(function () {
        // Open the second navigation
        if (window.innerWidth > 991) {
            document.querySelector('.infographic-circle__navigation--2 .infographic-circle__navigation-image').click();
        }
    }, 1500);

    // Open the first accordion
    document.querySelector('.infographic-circle__accordion details summary').click();

    // Add width change event
    window.addEventListener('resize', function () {
        if (window.innerWidth < 991) {
            resetInfographNavigations();
        }
    });
});